import * as React from 'react'
import { Checkbox, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import DeleteLocationDialog from 'components/container/page/location/DeleteLocationDialog'
import PlatButton from 'components/presenter/buttons/PlatButton'
import cn from 'classnames'
import * as styles from './styles.module.css'


// mode = list | select | view

const ShopLocationTableCore = ({className = '', mode = 'list', data = [], selected = [], onSelectAll, onSelect, emptyHint}) => {
  const { t } = useTranslation()
  const [deleteShop, setDeleteShop] = React.useState(null)

  const handleClickOpenDeleteDialog = (shop) => {
    setDeleteShop(shop)
  }

  const handleCloseDeleteDialog = () => {
    setDeleteShop(null)
  }

  const displayDistrict = (row) => {
    const lastTwo = row.regionals.slice(-2)
    return `${lastTwo[0].name} / ${lastTwo[1].name}`
  }

  const handleSelectAllClick = (event) => {
    if (onSelectAll) {
      if (event.target.checked) {
        onSelectAll(data)
        return
      }
      onSelectAll([])
    }
  }

  const handleSelectClick = (row) => (event) => {
    if (onSelect) {
      onSelect(row, event.target.checked)
    }
  }

  const numSelected = selected.length
  const rowCount = data.length
  const isRowSelected = row => !!selected.find(select => select._id === row._id)

  return (
    <>
      {
        data.length > 0 ?
        <>
          <Table className={cn(styles.table, className)}>
            <TableHead>
              <TableRow>
                { mode === 'select' 
                  ? <TableCell>
                      <Checkbox
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        className='mui-checkbox'
                        onChange={handleSelectAllClick} />
                    </TableCell>
                  : <></>
                }
                <TableCell>{t('shopLocation.shopName')}</TableCell>
                <TableCell>{t('shopLocation.district')}</TableCell>
                <TableCell>{t('shopLocation.address')}</TableCell>
                <TableCell>{t('shopLocation.shopPhone')}</TableCell>
                <TableCell>{t('formFields.type')}</TableCell>
                <TableCell>{t('shopLocation.shopGeoLocation')}</TableCell>
                { mode === 'list' ? <TableCell>{t('common.action')}</TableCell> : <></>}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row) => (
                <TableRow key={row._id}>
                  { mode === 'select' 
                    ? <TableCell>
                        <Checkbox
                          className='mui-checkbox'
                          checked={isRowSelected(row)}
                          onChange={handleSelectClick(row)} 
                        />
                      </TableCell>
                    : <></>
                  }
                  <TableCell>
                    {row.name}
                  </TableCell>
                  <TableCell>{displayDistrict(row)}</TableCell>
                  <TableCell>{row.address}</TableCell>
                  <TableCell>{row.telephone || 'NA'}</TableCell>
                  <TableCell>{row.category.name}</TableCell>
                  <TableCell>
                    <a
                      className={styles.mapLink}
                      href={`https://maps.google.com/?q=${row.geo_location.lat},${row.geo_location.lng}`}
                      target="_blank"
                    >
                      {t('shopLocation.map')}
                    </a>
                  </TableCell>
                  { 
                    mode === 'list'
                    ? <TableCell>
                        <PlatButton
                          className={styles.deleteBtn}
                          onClick={() => handleClickOpenDeleteDialog(row)}
                        >
                          {t('common.delete')}
                        </PlatButton>
                      </TableCell>
                    : <></>
                  }
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {
            deleteShop
            ? <DeleteLocationDialog
                shop={deleteShop}
                open
                onClose={handleCloseDeleteDialog}
                onDelete={handleCloseDeleteDialog}
              />
            : <></>        
          }
        </> 
        : <>
            <p className={styles.noShopTxt}>{emptyHint ?? t('shopLocation.noShops')}</p>
          </>
      }
            
    </>
  )
}

export default ShopLocationTableCore